import { Paths } from "../constants/UrlConstants";

const accountDetails = "Account details";
const profileDetails = "Profile Details";

const MyProfileHeader = {
  Heading: { Any: "My profile", HOL: "My account" },
  Links: [
    {
      Text: { Any: profileDetails, HOL: accountDetails },
      Link: Paths.MyProfile
    },
    {
      Text: "Communication settings",
      Link: Paths.MyProfileContactPreferences
    },
    {
      Text: "Permissions",
      Link: Paths.Permissions
    }
  ],
  LinksWithoutPreferences: [
    {
      Text: { Any: profileDetails, HOL: accountDetails },
      Link: Paths.MyProfile
    },
    {
      Text: "Permissions",
      Link: Paths.Permissions
    }
  ],
  LinksWithoutPermissions: [
    {
      Text: { Any: profileDetails, HOL: accountDetails },
      Link: Paths.MyProfile
    },
    {
      Text: "Communication settings",
      Link: Paths.MyProfileContactPreferences
    }
  ],
  LinkWithoutPermissionsOrPrefs: [
    {
      Text: { Any: profileDetails, HOL: accountDetails },
      Link: Paths.MyProfile
    }
  ]
};

export default MyProfileHeader;
